import { RouteConfig } from "vue-router";
import Error404 from "@/views/errors/404.vue";

// MasterLayout
import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";

// Register
import registerRoutes from "./register";
import defaultRoutes from "./default";
import departmentRoutes from "./department";
import serviceRoutes from "./services";
// import Home from "@/views/Home.vue";
import Dashboard from "@/views/SelfCare/DashBoard.vue";
import organizationRoutes from "./organization";
import permissionRoutes from "./permission";
import rolesRoutes from "./roles";
import reportRoutes from "./report";
import customRoutesPermissionRoutes from "./customRoutesPermission";
import databaseConnectionRoutes from "./databaseConnection";

// CBS Routes
import CBSAPIGatewayRoutes from "./CBSApiGateway";
import CBSAccountingRoutes from "./CBSAccounting";
import CBSCommissionRoutes from "./CBSCommission";
import CBSPaymentRoutes from "./CBSPayment";
import CBSProductRoutes from "./CBSProduct";
import operationalLogs from "./operational_logs";
import CBSProductRatingRoutes from "./CBSProductRating";
import CBSUserManagementRoutes from "./CBSUserManagement";
import CBSSubscriptionRoutes from "./CBSSubscription";
import CBSInvoice from "./CBSInvoice";

// Selfcare Routes
import SelfcareRoute from "./SelfCare";

// @ts-ignore
const baseRoutes: Array<RouteConfig> = [
  // {
  //   path: "/",
  //   name: "/",
  //   component: Dashboard,
  //   meta: {layout: MasterLayout, requireAuth: true},
  // },

  // {
  //   path: "/admin",
  //   name: "/admin",
  //   component: Dashboard,
  //   meta: {layout: MasterLayout, requireAuth: true},
  // },

  {
    path: "/admin/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
    meta: { layout: MasterLayout, requireAuth: true },
  },
  {
    path: "/admin/auth/users",
    name: "Users",
    component: () => import("../views/User/UserList.vue"),
    meta: { layout: MasterLayout, requireAuth: true },
  },
  {
    path: "/admin/auth/users/add",
    name: "UserAdd",
    component: () => import("../views/User/UserForm.vue"),
    meta: { layout: MasterLayout, requireAuth: true },
  },
  {
    path: "/admin/auth/users/edit/:id",
    name: "UserEdit",
    component: () => import("../views/User/UserForm.vue"),
    meta: { layout: MasterLayout, requireAuth: true },
  },
  {
    path: "/admin/auth/users/view/:id",
    name: "UserView",
    component: () => import("../views/User/UserView.vue"),
    meta: { layout: MasterLayout, requireAuth: true },
  },
  {
    path: "/admin/auth/profile",
    name: "AuthProfile",
    component: () => import("../views/User/AuthProfile.vue"),
    meta: { layout: MasterLayout, requireAuth: true },
  },
  {
    path: "/admin/auth/notifications",
    name: "AuthNotifications",
    component: () => import("../views/User/AuthNotifications.vue"),
    meta: { layout: MasterLayout, requireAuth: true },
  },
  {
    path: "/admin/auth/notifications/:id/show",
    name: "AuthNotificationShow",
    component: () => import("../views/User/AuthNotificationShow.vue"),
    meta: { layout: MasterLayout, requireAuth: true },
  },
  {
    path: "/admin/auth/update-password",
    name: "AuthChangePassword",
    component: () => import("../views/User/UpdatePassword.vue"),
    meta: { layout: MasterLayout, requireAuth: true },
  },
  {
    path: "/admin/auth/ext/change-password",
    name: "UserPasswordReset",
    component: () => import("../views/User/UserPasswordReset.vue"),
    meta: { layout: MasterLayout, requireAuth: true },
  },

  {
    path: "/admin/posts",
    name: "PostList",
    component: () => import("../views/Post/PostList.vue"),
    meta: {
      requireAuth: true,
      layout: MasterLayout,
    },
  },
  {
    path: "/admin/posts/add",
    name: "PostAdd",
    component: () => import("../views/Post/PostForm.vue"),
    meta: {
      requireAuth: true,
      layout: MasterLayout,
    },
  },
  {
    path: "/admin/posts/:id/edit",
    name: "PostEdit",
    component: () => import("../views/Post/PostForm.vue"),
    meta: {
      requireAuth: true,
      layout: MasterLayout,
    },
  },
  {
    path: "/admin/posts/:id/show",
    name: "PostShow",
    component: () => import("../views/Post/PostShow.vue"),
    meta: {
      requireAuth: true,
      layout: MasterLayout,
    },
  },
  //##Routes##//
];

const routes = baseRoutes.concat(
  registerRoutes,
  defaultRoutes,
  departmentRoutes,
  serviceRoutes,
  organizationRoutes,
  permissionRoutes,
  rolesRoutes,
  operationalLogs,
  reportRoutes,
  customRoutesPermissionRoutes,
  databaseConnectionRoutes,

  // CBS Routes
  // CBSAPIGatewayRoutes,
  // CBSAccountingRoutes,
  // CBSCommissionRoutes,
  // CBSPaymentRoutes,
  // CBSProductRoutes,
  // CBSProductRatingRoutes,
  // CBSUserManagementRoutes,
  // CBSSubscriptionRoutes,
  // CBSInvoice,

  // SelfCare Routes
  SelfcareRoute
);

export default routes;
